//買い物関連のスクリプト
(function($) {
  'use strict';


  var connecting = false;
  function ajaxCompareShopping( self , callback ) { 
    //console.log( 'req shopping '+self.data('asin'));
    
    if ( !self.data('nonce') ) {
      return;
    }

    //他の接続が終わるのを待つ
    if ( connecting ) {
      setTimeout( function() {
        ajaxCompareShopping( self, callback );
      },100);
      return;
    }


    connecting = true;
    var data = {
        'action': 'shopping_compare',
        '_ajax_nonce': self.data('nonce'),
        'jan': self.data('jan'),
        'asin': self.data('asin'),
        'keyword': self.data('keyword'),
        'type' : self.data('type'),
        'hide' : self.data('hide'),
        'cache' : self.data('cache'),
        'style': self.data('style'),
        'only_available' : self.data('only_available'),
        'version' : self.data('version'),
        'is_new_template_v2' : self.data('is_new_template_v2'),
    };
    //console.log(data);
    return $.ajax({
      url: moko.ajaxurl,
      type: 'POST',
      dataType: 'text',
      timeout: 30000,
      cache : false,
      data: data,
    }).fail(function(xhr, status, error) {
      console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
      console.error('通信エラー');
      self.find('.message').text('価格の読み込みに失敗しました');
      //alert('通信エラー');
    }).done(function(data) {
      //console.log('req done '+self.data('asin'));
      if ( self && data ) {
        self.html(data);
        moko.initEvents(self);
      }
    }).always(function() {
      connecting = false;
      callback();
    });
  }



  //最初から見えてるバーション
  $('.shopping-compare').each( function( ) {
    var self = $(this);
    ajaxCompareShopping(self, function() {
    } );
  });


  //ボタンリンクバージョン
  $('.shopping-compare-link').one( 'click', function() {
    var btn =$(this).find('.btn-shopping-compare');
    var container = $(this).find('.shopping-compare-hide');
    container.show();
    ajaxCompareShopping(container,function() {
      btn.hide();
    });
  });

})(jQuery);
